<template>
  <span :class="underConsultationClass">
    <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span>
            <v-icon
              v-bind="attrs"
              v-on="on"
              large
              :color="consultation.color"
              @click="doConsultation"
            >mdi-account-child-circle</v-icon>
          </span>
        </template>
        <span>Under Consultation</span>
      </v-tooltip>
    </template>
  </span>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'under-consultation',
  props: {
    loan: Object
  },
  data () {
    return {
      ConsultationFlags: {
        NOT_UNDER_CONSULTATION: 0,
        UNDER_CONSULTATION: 1
      },
      consultation: {
        color: 'primary',
        consultationFlag: 0
      },
      underConsultationClass: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId: {
      handler: function () {
        if (this.$route.path.includes(DataType.RouterPath.LOS_PATH)) {
          this.underConsultationClass = 'under-consultation-style'
        }
        this.getConsultationFlag(this.loan.id)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getConsultationFlag (loanId) {
      const request = {
        loanId: loanId,
        feature: 'CONSULTATION'
      }
      const $this = this
      OriginationApi.getSectionFeature(request, function (consultationData) {
        if (tool.isNotEmpty(consultationData)) {
          $this.consultation = {
            color: '#f44336',
            consultationFlag: $this.ConsultationFlags.UNDER_CONSULTATION
          }
        }
      })
    },
    doConsultation () {
      const $this = this
      const updateConsultationFlag = ($this.consultation.consultationFlag === $this.ConsultationFlags.NOT_UNDER_CONSULTATION
        ? $this.ConsultationFlags.UNDER_CONSULTATION : $this.ConsultationFlags.NOT_UNDER_CONSULTATION)
      const saveData = {
        loanId: this.loan.id,
        feature: 'CONSULTATION'
      }
      OriginationApi.updateSectionFeature(saveData, function () {
        $this.consultation = {
          color: updateConsultationFlag === $this.ConsultationFlags.NOT_UNDER_CONSULTATION ? 'primary' : '#f44336',
          consultationFlag: updateConsultationFlag
        }
        $this.$forceUpdate()
      }, function (err) {
        popup.popupForWarning(err.message)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .under-consultation-style {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    color: white;
    opacity: 0.88;
    height: 10px;
    margin-right: 10px;
    margin-top: 1px;
  }
  .material-icons.md-36 { font-size: 36px; }
  .material-icons.md-48 { font-size: 48px; }
  .group {
    display: flex;
    flex: 1;
    justify-content: space-around;
  }
</style>
